import type { TFunction } from "i18next";

/**
 * Maps stable server-side auth error codes (returned by Zod schemas and
 * login/join actions) to i18n keys in `authPage`. Any string that is not in
 * this map (e.g. raw Supabase auth errors) is returned as-is so the user
 * still sees an informative message.
 */
const AUTH_ERROR_KEY_MAP: Record<string, string> = {
  invalid_email: "authPage.errorInvalidEmail",
  password_min: "authPage.errorPasswordMin",
  name_required: "authPage.errorNameRequired",
  passwords_must_match: "authPage.errorPasswordsMustMatch",
  must_agree_terms: "authPage.errorMustAgreeTerms",
  email_exists: "authPage.errorEmailExists",
  "Email not confirmed": "authPage.errorEmailNotConfirmed",
  captcha_failed: "authPage.errorCaptchaFailed",
};

export function translateAuthError(
  code: string | undefined,
  t: TFunction,
): string {
  if (!code) return "";
  const key = AUTH_ERROR_KEY_MAP[code];
  return key ? t(key) : code;
}

export function translateAuthErrors(
  codes: (string | undefined)[] | undefined,
  t: TFunction,
): string[] {
  if (!codes) return [];
  return codes
    .filter((c): c is string => Boolean(c))
    .map((c) => translateAuthError(c, t));
}
